
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 18 18"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M5.596 0c-2.48 0-4.511 2.026-4.511 4.5a4.5 4.5 0 001.958 3.699 4.677 4.677 0 00-1.696 1.198C.434 10.432 0 11.859 0 13.455v4.201l.597.244c.149.06.323.1.516.1h8.966c.193 0 .367-.04.516-.1l.597-.244v-4.201c0-1.596-.434-3.023-1.347-4.058A4.677 4.677 0 008.15 8.199 4.499 4.499 0 0010.107 4.5c0-2.474-2.031-4.5-4.511-4.5zm0 1.929A2.56 2.56 0 018.174 4.5a2.56 2.56 0 01-2.578 2.571A2.56 2.56 0 013.018 4.5a2.56 2.56 0 012.578-2.571zm0 7.714c1.493 0 2.282.443 2.797 1.027.527.598.866 1.54.866 2.785v2.616H1.933v-2.616c0-1.245.339-2.187.866-2.785.515-.584 1.304-1.027 2.797-1.027z","font-family":"sans-serif","overflow":"visible"}}),_c('path',{attrs:{"d":"M17.958 6.297c-.197-.665-1.325-.522-1.295.192.056.887-.334 1.803-1.118 2.264-1.182.774-2.956.128-3.364-1.22-.423-1.136.242-2.48 1.37-2.894-.47.43-.125 1.334.558 1.19.666-.305 1.151-.931 1.733-1.377.38-.3.87-.647.226-.96-.64-.525-1.224-1.153-1.937-1.569-.756-.197-1.113.955-.437 1.277-1.778.295-3.143 2.06-2.98 3.852.081 1.867 1.806 3.438 3.67 3.382 1.888.035 3.598-1.625 3.61-3.508.006-.21.02-.425-.036-.629z"}})])
          )
        }
      }
    